import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/content/:contentId/documents/`;
const pathById = `${pathBase}:documentId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const documents = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
} as const;
